import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'jiraservicedesk-connector-panel',
    templateUrl: './jiraservicedesk.connector.panel.html'
})
export class JIRAServiceManagementConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@JIRA Service Management',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.JIRAServiceManagementInfo',
            ControlType: JIRAServiceManagementConnectorPanel,
            Default: null
        };
    }
}
